import React,{useEffect,useState} from "react";
import Burger from "../assets/Humburger.png";
import facebook from "../assets/facebook.png";
import twitter from "../assets/twitter.png";
import linkedin from "../assets/linkedin.png";
import logo from "../assets/logos/afrinovator logo-11.png";
import "./Navbar.css";

function Narvbar({ showPopup, setShowPopup }) {
    const [showAppBar, setShowAppBar] = useState(false);
    const [lastScrollTop, setLastScrollTop] = useState(0);

    useEffect(() => {
      const handleScroll = () => {
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        setShowAppBar(scrollTop > 300);
        setLastScrollTop(scrollTop);
      };
  
      window.addEventListener("scroll", handleScroll);
  
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, [lastScrollTop]);

  return (
    <nav className="nav-container">{
        !showAppBar?
        (<div className="small-nav">
        <p>Let us be part of your vision</p>
        <ul className="small-nav-menu">
          <li><a href="#careers">Careers</a></li>
          <li><a href="#blog">Blog</a></li>
          <li><a href="#contact">contact us!</a></li>
        </ul>
      </div>):""
    }
      <div className="nav-wrapper">
        <div className="nav-left">
          <a href="#About">
            <img className="nav-logo" src={logo}></img>
          </a>
          <ul className="nav-menu">
            <li>
              <a href="#About">About</a>
            </li>
            <li>
              <a href="#Services">Services</a>
            </li>
            <li>
              <a href="#clients">Our clients</a>
            </li>
            <li>
              <a href="#Contact" className="booking-btn">Book a call</a>
            </li>
          </ul>
        </div>

        <div className="nav-socials-container">
          <ul className="nav-socials">
            <li>
              <a href="#">
                <img src={linkedin} alt="linkedIn Icon" />
              </a>
            </li>
            <li>
              <a href="#">
                <img src={twitter} alt="twitter Icon" />
              </a>
            </li>
            <li>
              <a href="#">
                <img src={facebook} alt="facebook Icon" />
              </a>
            </li>
          </ul>
          {!showPopup ? (
            <img
              src={Burger}
              onClick={() => setShowPopup(true)}
              alt="humburger"
              className="humburger"
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </nav>
  );
}

export default Narvbar;
